// styles
import { chartDashboardBoxStyle, chartDashboardType01Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledTodayEntry = styled.div`
  ${chartDashboardBoxStyle}
  ${chartDashboardType01Style}
`;
